import { render, staticRenderFns } from "./UpdateCardholderLimitCard.vue?vue&type=template&id=67697b70&scoped=true"
import script from "./UpdateCardholderLimitCard.vue?vue&type=script&lang=js"
export * from "./UpdateCardholderLimitCard.vue?vue&type=script&lang=js"
import style0 from "./UpdateCardholderLimitCard.vue?vue&type=style&index=0&id=67697b70&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67697b70",
  null
  
)

export default component.exports